/**
 * Tax module constants.
 */

/** Maps One Source API field names to Commercetools line item custom field names. */
export const TAX_FIELD_MAPPING: Record<string, string> = {
  erpTaxCode: 'erpTaxCode',
  natureOfTax: 'natureOfTax',
  taxableCity: 'taxableCity',
  taxableState: 'taxableState',
  taxableCountry: 'taxableCountry',
  zoneLevel: 'taxZoneLevel',
  zoneName: 'taxZoneName',
};

/** Default currency if cart currency is missing. */
export const DEFAULT_CURRENCY = 'GBP';

/** Default product name fallback. */
export const DEFAULT_PRODUCT_NAME = 'Sample Product';

/** Default Point of Title Transfer for One Source. */
export const DEFAULT_TITLE_TRANSFER = 'I';

/** Default Language for One Source Request. */
export const DEFAULT_PRIMARY_LANGUAGE = 'en';

/** Commercetools Action for setting external tax rate. */
export const ACTION_SET_LINE_ITEM_TAX_RATE = 'setLineItemTaxRate';

/** Commercetools Action for setting line item custom field. */
export const ACTION_SET_LINE_ITEM_CUSTOM_FIELD = 'setLineItemCustomField';

/** External Tax Rate Name used in Commercetools actions. */
export const EXTERNAL_TAX_RATE_NAME = 'Custom Tax';

/** Attribute names in Commercetools line items used for tax request building. */
export const TAX_ATTRIBUTES = {
  TRANSACTION_TYPE: 'transactionType',
  TITLE_TRANSFER: 'pointOfTitleTransfer',
  PRODUCT_TAX_CATEGORY: 'productTaxCategory',
};

/** Custom field names in One Source addresses. */
export const TAX_ADDRESS_FIELDS = {
  COUNTRY_NAME: 'countryName',
  STATE_CODE: 'stateCode',
  TAX_NUMBER: 'taxNumber',
  USER_PROFILE_ID: 'userProfileId',
};

/** Country codes used for logic branches (e.g. province vs state). */
export const TAX_COUNTRIES = {
  USA: 'US',
  CANADA: 'CA',
};

/** Tax calculation API path (co-located re-export from shared). */
export { TAX_CALCULATE } from '../../../shared/constants/api';
